<template>
    <div class="SystemStepItem">
        <div class="item-wrapper">
            <div
                class="image"
                :style="{
                    backgroundImage: 'url(https://picsum.photos/200)'
                }"
            />
            <div class="content">
                <div class="stepNumber gray-text">
                    <span class="stepLabel">{{ $tc('dashboard.general.step') }} </span> {{ index }}
                </div>
                <div class="bold-title"> {{ step.name }} </div>
                <div class="spacer" />

                <div class="activities">
                    <SystemItemActivity
                        v-for="(activity, i) of systemActivities"
                        :key="i"
                        :activity="activity"
                        class="Activity"
                        @click="activity.redirect()"
                    />
                </div>
            </div>
            <div class="button-wrapper">
                <a class="button-blue" @click="goToSystemMainView()">Start</a>
            </div>
        </div>
        <StepBullet :current="false" icon="steps-3" />
    </div>
</template>

<script>
import SystemItemActivity from './SystemItemActivity';
import StepBullet from '@/modules/course/components/StepBullet';

export default {
    components: {
        SystemItemActivity,
        StepBullet
    },

    props: {
        systemId: {
            type: String,
            required: true,
            default: ''
        },

        groupName: {
            type: String,
            required: false,
            default: ''
        },

        journey: {
            type: Object,
            required: true,
            default: () => {}
        },

        step: {
            type: Object,
            required: true,
            default: () => {}
        },

        index: {
            type: Number,
            required: true,
            default: 0
        },

        hasSystemGames: {
            type: Boolean,
            required: false,
            default: true
        }
    },

    data() {
        return {
            activities: [
                {
                    name: 'memorize',
                    icon: 'activities/memo-overview',
                    redirect: this.goToStepMemorizeView
                },
                {
                    name: 'quiz2',
                    icon: 'activities/system-activity'
                }
            ],
            routeParams: {
                systemId: this.systemId,
                groupName: this.urlifyString(this.groupName) || 'no-group',
                journeyName: this.urlifyString(this.journey.name),
                stepName: this.urlifyString(this.step.name)
            }
        };
    },

    computed: {
        systemActivities() {
            const memorizeActivity = [this.activities[0]];

            return this.hasSystemGames ? this.activities : memorizeActivity;
        }
    },

    methods: {
        goToSystemMainView() {
            this.$router.push({
                name: 'SystemMainView',
                params: {
                    ...this.routeParams
                }
            });
        },

        goToStepMemorizeView() {
            this.$router.push({
                name: 'StepMemorizeView',
                params: {
                    ...this.routeParams
                }
            });
        },

        urlifyString(string) {
            return string.toLowerCase().split(' ').join('-');
        }
    }
};
</script>

<style lang="scss" scoped>
.SystemStepItem {
    position: relative;
    border-radius: 1em;
    background-color: white;
    display: flex;
    cursor: pointer;
}
.item-wrapper {
    display: flex;
    align-items: center;
    width: 100%;
    padding-bottom: 22px;
    border-bottom: 1px solid rgba(133, 133, 133, 0.12);
    @media (max-width: 530px) {
        align-items: flex-start;
    }
    .content {
        width: 100%;
        margin-left: 26px;
        padding-right: 15px;
        @media (max-width: 530px) {
            margin-left: 16px;
            padding-right: 0;
        }
    }
}

.image {
    min-width: 6.1em;
    min-height: 6.1em;
    border-radius: 13.3405px;
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    @media (max-width: 530px) {
        min-width: 48px;
        min-height: 48px;
        margin-top: 0.5em;
    }
}

.spacer {
    flex: 1;
}

.stepLabel {
    text-transform: capitalize;
    @media (max-width: 530px) {
        font-size: 14px;
    }
}
.stepNumber {
    text-transform: uppercase;
}
.bold-title {
    margin-bottom: 1.25em;
    @media (max-width: 530px) {
        font-size: 16px;
        margin-bottom: 0.5em;
    }
}

.activities {
    display: flex;
    margin-top: 1em;
}
.Activity {
    &:not(:first-child) {
        margin-left: 1em;
        @media (max-width: 530px) {
            margin-left: 1em;
        }
    }
}

.StepBullet {
    display: none;
    position: absolute;
    top: -0.5em;
    right: -0.5em;
}

.button-wrapper {
    .button-blue {
        cursor: pointer;
    }
    @media (max-width: 1000px) {
        display: none;
    }
}

.gray-text {
    @media (max-width: 530px) {
        font-size: 14px;
    }
}
</style>
